import {createSlice,createAsyncThunk} from "@reduxjs/toolkit";

const data = {
    id:"435498966",
    name:null,
    description:null,
    isFinished:false,
    time:null,
    data:[
        {
            id:"6878767",
            question:null,
            response:null,
            isSended:false
        }
    ],
    score:null
}

const testSlice = createSlice({
    name:'test', 
    initialState:{ 
        loading: false,
        test :data
    },
    reducers:{
        add_test:(state,action)=>{
            state.test = action.payload
        },
        delete_test:(state)=>{
            state.test = data
        }
    }
})

export const {add_test,delete_test} = testSlice.actions;
export default testSlice.reducer;